<template>
  <div>
    <v-card>
      <v-card-title>Asignar Agente</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-combobox
              v-model="agente"
              :items="agentes"
              item-text="nombre"
              item-value="nombre"
              label="Agente"
              append-icon="check_circle"
              return-object
              :disabled="disableAll"
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="guia"
              label="No. de Guía"
              :disabled="disableAll"
              append-icon="dashboard"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-dialog
              ref="dialogFecha"
              v-model="modalFecha"
              :return-value.sync="fecha"
              persistent
              width="290px"
              :disabled="disableAll"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fecha"
                  label="Fecha"
                  append-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :disabled="disableAll"
                ></v-text-field>
              </template>
              <v-date-picker
                :disabled="disableAll"
                v-model="fecha"
                scrollable
                no-title
                @input="
                  modalFecha = false;
                  $refs.dialogFecha.save(fecha);
                "
              >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
            type="time"
            v-model="hora"
            label="Hora"
            clearable
            :disabled="disableAll"
          >
          </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><v-btn :disabled="disableAll" color="primary" outlined @click="enviarProv()">
          Agregar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {
      modalFecha: false,
      fecha: null,
      hora: null,
      agentes: [],
      agente: null,
      guia: null,
      overlay: false,
      disableAll: false,
    };
  },
  methods: {
    fillAgentes: function () {
      apicon.getDataApi(apicon.getApiBaseUrl() + "agente").then((result) => {
        this.agentes = result;
      });
    },
    enviarProv: async function (id) {
      if (this.agente != null) {
        if (this.guia != null) {
          if (this.fecha != null) {
            this.overlay = true;
            await apicon
              .saveDataApi(apicon.getApiBaseUrl() + "asignaragente", {
                id: this.id,
                agente: this.agente.nombre,
                guia: this.guia,
                fecha: this.fecha,
                hora: this.hora,
              })
              .then((result) => {
                this.overlay = false;
                this.disableAll = true;
                this.$swal(result.message);
              });
          } else {
            this.$swal("Por favor seleccione la fecha...");
          }
        } else {
          this.$swal("Por favor ingrese el número de guía...");
        }
      } else {
        this.$swal("Por favor seleccione un agente...");
      }
    },
  },
  mounted: function () {
    apicon.setAuthHeaders();
    this.fillAgentes();
  },
};
</script>
